// extracted by mini-css-extract-plugin
export var messageSideLeft = "_on-1";
export var messageSideRight = "_on-2";
export var subscribeToBackInStockBubbleContainer = "_on-0";